// AudioFactory.ts
import { IAudio } from './IAudio';
import { WebAudioHtml5Backend, AudioEngineOptions } from './WebHtml5Service';
import { HowlerBackend, HowlerBackendOptions } from './HowlerService';

export class AudioFactory {
  static create(
    opts: AudioEngineOptions,
    prefer: 'howler' | 'webaudio' = 'webaudio'
  ): IAudio {
    if (prefer === 'howler') {
      const howlerOpts: HowlerBackendOptions = {
        slug: opts.slug,
        assetManager: opts.assetManager,
        soundMap: opts.soundMap,
        soundVolumes: opts.soundVolumes,
        duckMusicOnSfx: opts.duckMusicOnSfx,
        musicDuckRatio: opts.musicDuckRatio,
      };
      return new HowlerBackend(howlerOpts);
    }
    return new WebAudioHtml5Backend(opts);
  }
}
